import styled from "styled-components";

const VideoContainer = styled.div`
    display: flex;
    position: relative;
    min-height: 200px;
    max-height: 250px;
    background-color: #1d1d1f;
    margin-bottom: 20px;
`;

export default VideoContainer;